<template>
  <div class="submissions" v-if="forms!=null && form_elements!=null">
    <section class="archive" v-if="forms">
      <section class="manage-archive" v-if="forms?.[$route.params.form_id][0].permission>=3">
        <ButtonAction1 class="archive-button" label="Manage Archive" @click="openArchiveDialog()"/>
        <dialog ref="archive_dialog" class="archive-dialog" :class="{'open':dialog_open}">
          <section class="options">
            <Radio @change="archive_radio_direction_value=$event" :preset="0" label="Handle selected submissions" ref="archive_options_direction" :options="[{id:0,label:'Move selected submission(s) to Archive'},{id:1,label:'Remove selected submission(s) from Archive(s)'}]"/>
            <Radio @change="archive_radio_key_value=$event" v-if="archive_radio_direction_value==0" :preset="archive_radio_key_value" label="Selected Archive" :options="archive_options_key" ref="archive_options_key"/>
            <InputElement ref="archive_group_input" label="Enter new archive name" v-if="archive_radio_direction_value==0 && archive_radio_key_value==-1" placeholder="name..." :required="true"/>
          </section>
          <section class="buttons">
            <ButtonAction1 class="archive-button" label="Cancel" @click="closeArchiveDialog()"/>
            <ButtonAction1 class="archive-button" label="Confirm" @click="confirmArchiveDialog()" :loading="archive_submit_loading" ref="archive_confirm_button"/>
          </section>
        </dialog>
      </section>
      <section class="display-archives">
        <div class="display-archive" v-for="(value,key) in forms[$route.params.form_id][0].archive_groups" :key="key">
          <button class="archive-button" @click="toggleArchive(key)">{{key}}</button>
          <template v-if="key in archive_submissions">
            <TableAll @option="handleArchiveOption($event)" :row_options="archive_row_options" :dataMap="mapSubmissions" v-model="archive_filter_string" :search="false" :loading="!(key in archive_submissions)" :filename="`${filename}_archive_${key}`" :select="true" :ref="`table_${key}`" :filter="true" :self_order="true" placeholder="filter..." :data="archive_submissions[key]" :columns="value"/>
          </template>
        </div>
      </section>
    </section>
    <section class="table">
      <TableAll :getSideNavigationWidth="getSideNavigationWidth" :annotate_by_id="true" :annotate="replies" :highlight_by_id="true" @option="handleLiveOption($event)" :row_options="row_options" @downloadAll="downloadAll($route.params.form_id,$route.query.search,$route.query.order_col,$route.query.order_asc)" :filename="filename" :select="true" ref="table" :filter="true" :loading="awaiting_submissions" :self_order="false" @search="handleSearchEvent($event)" @order="handleOrderEvent($event)" @page="handlePageEvent($event)" :n_pages="n_pages" v-model="search_string" placeholder="filter..." :data="submissions" :columns="columns"/>
    </section>
  </div>
</template>

<script>
import TableAll from '@/components/table/TableAll.vue'
import Radio from '@/components/inputs_23/Radio.vue'
import InputElement from '@/components/inputs_23/InputElement.vue'
import axios from 'axios';
import ButtonAction1 from '@/components/buttons/ButtonAction1.vue'
// import JSONToTable from '@/components/table/JSONToTable.vue'
export default {
  name: 'Submissions',
  components: {
    TableAll,
    ButtonAction1,
    Radio,
    InputElement,
    // JSONToTable,
  },
  props: {
    forms: Object,
    form_elements: Object,
    organization: Object,
  },
  data() {
    return {
      row_options: [
        {id: 0,icon: 'create-outline', text: 'View / Edit Submission', name: 'editSubmission', permission: 2, two_step: false, dataset_permission: 2, await:false},
        {id: 1,icon: 'copy-outline', text: 'Copy Submission', name: 'copySubmission', permission: 1, two_step: false, dataset_permission: 2, await:true},
        {id: 2,icon: 'lock-closed-outline', text: 'Archive', name: 'archiveSubmission', permission: 5, two_step: false, dataset_permission: 4, await:true},
        {id: 3,icon: 'trash-outline', text: 'Delete Submission', name: 'deleteSubmission', permission: 3, two_step: true, dataset_permission: 2, await:true},
      ],

      archive_row_options: [
        {id: 0,icon: 'lock-open-outline', text: 'Remove from Archive', name: 'dearchiveSubmission', permission: 3, twoStep: false, dataset_permission: 4, await:true},
        {id: 1,icon: 'copy-outline', text: 'Copy Submission', name: 'copyArchiveSubmission', permission: 1, two_step: false, dataset_permission: 2, await:true},
      ],

      archive_radio_direction_value: 0,
      archive_radio_key_value: -1,
      // archive_input_key_value: 0,

      submissions: [],
      search_string: null,
      archive_filter_string: '',
      n_pages: null,
      page: null,
      awaiting_submissions: false,
      dialog_open: false,
      archive_submit_loading: false,
      awaiting_archive_submissions: {},
      awaiting_copy_submission: false,
      archive_submissions: {},
      columns: [],
      replies: [],
    }
  },
  mounted() {
    console.log('mount')
    this.getSubmissions(this.$route.params.form_id,this.$route.query.search,this.$route.query.page,this.$route.query.order_col,this.$route.query.order_asc,this.$route.query.limit)
  },
  computed: {
    getSideNavigationWidth() {
      return this.$store.getters.getSideNavigationWidth 
    },
    archive_options_key() {
      const options = [{id:-1,label:'New Entrie'}]
      if(!this.forms || !this.forms[this.$route.params.form_id][0].archive_groups) {
        return options
      }
      Object.keys(this.forms[this.$route.params.form_id][0].archive_groups).forEach((key,index)=>{
        options.push({id:index,label:key})
      })
      return options
    },
    filename() {
      if(!this.forms) {
        return null
      }
      return this.forms[this.$route.params.form_id][0].name
    },
  },
  watch: {
    $route(to,from) {
      // if(to.params.form_id===from.params.form_id) {
      //   return
      // }
      // console.log(to)
      if(to.name==='submissions' || to.query.search!=from.query.search || to.query.page!=from.query.page || to.query.order_col!=from.query.order_col || to.query.order_asc!=from.query.order_asc) {
        this.getSubmissions(to.params.form_id,to.query.search,to.query.page,to.query.order_col,to.query.order_asc,to.query.limit)
      }
    }
  },
  methods: {
    async handleArchiveOption({option,row,table}) {
      if(option.id==0) {
        const {error} = await this.dearchiveSubmissions([row.id])
        this.$store.dispatch('__clear__')
        if(!error) {
          this.getSubmissions(this.$route.params.form_id,this.$route.query.search,this.$route.query.page,this.$route.query.order_col,this.$route.query.order_asc)
        }
        table.awaiting_option.delete(option.id)
        table.closeRowmenu()
      } else if(option.id==1) {
        await this.copySubmission(this.$route.params.form_id, row.id)
        table.awaiting_option.delete(option.id)
        table.closeRowmenu()
      }
    },
    async handleLiveOption({option,row,table}) {
      if(option.id==0) {
        this.$router.push({name:'submit', params: {form_id: this.$route.params.form_id,submission_id:row.id}})
      } else if(option.id==1) {
        await this.copySubmission(this.$route.params.form_id, row.id)
        table.awaiting_option.delete(option.id)
        table.closeRowmenu()
      } else if(option.id==2) {
        const {error} = await this.archiveSubmissions([row.id],'default')
        if(!error) {
          this.submissions = this.submissions.filter(submission=>submission.id!==row.id)
        }
        table.awaiting_option.delete(option.id)
        table.closeRowmenu()
      } else if(option.id==3) {
        const {error} = await this.deleteSubmission(this.$route.params.form_id,row.id)
        if(!error) {
          this.submissions = this.submissions.filter(submission=>submission.id!==row.id)
        }
        table.awaiting_option.delete(option.id)
        table.closeRowmenu()
      }
    },
    async deleteSubmission(form_id,submission_id) {
      const request_header = {method:'get',url:this.$store.getters.getApiUrl+`__submissions__/${form_id}/${submission_id}/delete`}
      const params = {}
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      this.awaiting_copy_submission = true
      const {error} = await axios(request_header).catch(error=>{return {data:null, error}})
      this.awaiting_copy_submission = false
      if(error) {
        console.log(error?.response)
      }
      return {error}
    },
    async dearchiveSubmissions(ids) {
      const formData = new FormData()
      formData.append('ids', JSON.stringify(ids))
      const request_header = {method:'post',url:this.$store.getters.getApiUrl+`__submissions__/${this.$route.params.form_id}/dearchive`, data:formData}
      const params = {}
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      this.archive_submit_loading = true
      const {data,error} = await axios(request_header).catch(error=>{return {data:null,error}})
      console.log(error?.response)
      this.archive_submit_loading = false
      return {data,error}
    },
    async archiveSubmissions(ids,archive_group) {
      const formData = new FormData()
      formData.append('ids', JSON.stringify(ids))
      if(this.$refs.archive_options_key.value==-1) {
        formData.append('archive_group', archive_group)
      } else {
        formData.append('archive_group', archive_group)
      }
      const request_header = {method:'post',url:this.$store.getters.getApiUrl+`__submissions__/${this.$route.params.form_id}/archive`, data:formData}
      const params = {}
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      this.archive_submit_loading = true
      const {data,error} = await axios(request_header).catch(error=>{return {data:null,error}})
      this.archive_submit_loading = false
      if(error) {
        console.log(error?.response)
      }
      return {data,error}
    },
    async copySubmission(form_id,submission_id) {
      const request_header = {method:'get',url:this.$store.getters.getApiUrl+`__submissions__/${form_id}/${submission_id}/copy`}
      const params = {
        owner:this.organization?JSON.stringify(this.organization):JSON.stringify(this.$store.getters.getProfile),
        owner_type:this.organization?1:0,
      }
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      this.awaiting_copy_submission = true
      const {data,error} = await axios(request_header).catch(error=>{return {data:null, error}})
      this.awaiting_copy_submission = false
      if(error) {
        console.log(error?.response)
        return
      }
      const submission = this.mapSubmissions([data.submission],this.columns)[0]
      this.submissions.unshift(submission)
      this.$router.push({query:{...this.$route.query,highlight:submission.id}})
      this.$store.dispatch('__clear__')
      this.getSubmissions(this.$route.params.form_id,this.$route.query.search,this.$route.query.page,this.$route.query.order_col,this.$route.query.order_asc)
    },
    handleSearchEvent(event) {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      query.search = event
      query.page = 1
      if(!event) {
        delete query.search
      }
      this.$router.push({query})
    },
    handlePageEvent(event) {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      query.page = event
      this.$router.push({query})
    },
    handleOrderEvent(event) {
      const query = JSON.parse(JSON.stringify(this.$route.query))
      query.order_col = JSON.stringify(event.col.id)
      query.order_asc = event.asc
      this.$router.push({query})
    },
    async confirmArchiveDialog() {
      if(this.$refs.archive_options_direction.value==0) {
        const selected_ids = this.$refs.table.getSelected().map(submission=>submission.id)
        var archive_group = ""
        if(this.$refs.archive_options_key.value==-1) {
          archive_group = this.$refs.archive_group_input.value
        } else {
          archive_group = this.$refs.archive_options_key.getLabel()
        }
        const {error} = await this.archiveSubmissions(selected_ids, archive_group)
        if(!error) {
          this.closeArchiveDialog()
        } else {
          this.$refs.archive_confirm_button.showError()
        }

      } else {
        var selected_ids = []
        Object.keys(this.forms[this.$route.params.form_id][0].archive_groups).forEach(key=>{
          selected_ids = selected_ids.concat(this.$refs[`table_${key}`].getSelected().map(submission=>submission.id))
        })
        const {error} = await this.dearchiveSubmissions(selected_ids)
        this.$store.dispatch('__clear__')
        if(!error) {
          this.getSubmissions(this.$route.params.form_id,this.$route.query.search,this.$route.query.page,this.$route.query.order_col,this.$route.query.order_asc)
          this.closeArchiveDialog()
        } else {
          this.$refs.archive_confirm_button.showError()
        }
      }
    },
    closeArchiveDialog() {
      this.dialog_open = false
      this.$refs.archive_dialog.close()
    },
    openArchiveDialog() {
      this.dialog_open = true
      this.$refs.archive_dialog.showModal()
      this.$refs.archive_dialog.addEventListener("mousedown", e=>{
        const dialog_rect = this.$refs.archive_dialog.getBoundingClientRect()
        if(e.clientX < dialog_rect.left || e.clientX > dialog_rect.right || e.clientY < dialog_rect.top || e.clientY > dialog_rect.bottom) {
          this.closeArchiveDialog()
        }
      })
    },
    mapSubmissions(submissions,columns) {
      const mapped_submissions = []
      if(!submissions || !columns) {
        return []
      }
      for(var i=0;i<submissions.length;i++) {
        const submission = JSON.parse(JSON.stringify(submissions[i]))
        columns.forEach(column=>{
          const form_element = column.el
          var value = submission
          if(!form_element || (form_element.component!=='SelectElement' && form_element.component!=='FileUploadElement')) {
            return
          }
          for(var j=0;j<column.id.length-1;j++) {
            if(value===null) {
              return
            }
            value = value[column.id[j]]
          }
          if(!form_element || value===null || value[column.id[column.id.length-1]]==null) {
            return
          }
          if(form_element.component==='SelectElement') {
            // console.log(value,form_element.data.data.find(option=>option.id==value[column.id[column.id.length-1]])?.name)
            value[column.id[column.id.length-1]] = form_element.data.data.find(option=>option.id==value[column.id[column.id.length-1]])?.name
          } else if(form_element.component==='FileUploadElement'){
            value[column.id[column.id.length-1]] = `<a href="${value[column.id[column.id.length-1]].url}">${value[column.id[column.id.length-1]].name}</a>`
          } 
        })
        mapped_submissions.push(submission)
      }
      return mapped_submissions
    },
    getColumnStacksRecursive(form_element,base=[],columns=[]) {
      if(form_element.component!=='SelectReferenceElement') {
        return columns
      }
      form_element.data.formElementIds.forEach(ref_form_element_id=>{
        const ref_form_element = this.form_elements[form_element.data.formId].find(form_element=>form_element.id==ref_form_element_id)
        const new_base = [...base,ref_form_element.id]
        this.getColumnStacksRecursive(ref_form_element,new_base,columns)
      })
      return columns
    },
    async toggleArchive(key) {
      if(key in this.archive_submissions) {
        delete this.archive_submissions[key] 
        return
      }
      const request_header = {method:'get',url:this.$store.getters.getApiUrl+`_forms/submissions/archive/${this.$route.params.form_id}/${key}`}

      const {data,error} = await axios(request_header).catch(error=>{return {data:null,error}})
      this.archive_submissions[key] = data
      console.log(error?.response)
    },

    async downloadAll(form_id,search=null,order_col=null,order_asc=null) {
      const request_header = {method:'get',url:this.$store.getters.getApiUrl+`__submissions__/${form_id}/all`}
      const params = {}
      if(search) {
        params.search=search
      }
      if(order_col && order_asc) {
        params.order_col = order_col
        params.order_asc = order_asc==="true" ? 1 : 0
      }
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      request_header.params = params
      const {data,error} = await axios(request_header).catch(error=>{return {data:null,error}})
      var submissions = data.submissions
      this.submissions = this.mapSubmissions(submissions,this.columns)
      this.$refs.table.all_data = submissions
      console.log(data,error?.response)
    },
    async getSubmissions(form_id,search=null,page=null,order_col=null,order_asc=null,limit=50) {
      if(limit===undefined || limit===null) {
        limit = 50
      }
      this.awaiting_submissions = true
      const params = {limit}
      if(search) {
        params.search=search
      }
      if(page) {
        params.page=page
      }
      if(order_col && order_col) {
        params.order_col = order_col
        params.order_asc = order_asc==="true" ? 1 : 0
      }
      params.key='jd(3.3329djHaiJK3023ld0OD=3'
      const {submissions, n_pages, columns,replies} = await this.$store.dispatch('__submissions__',{form_id,params})
      console.log('repls',replies)
      console.log('submissions', submissions)
      this.replies = replies
      this.columns = columns.sort((a,b)=>{
        if(a.position>=b.position) {
          return 1
        }
        return -1
      })
      console.log(this.columns, 'asdf123')
      this.submissions = this.mapSubmissions(submissions,this.columns)
      this.n_pages = n_pages
      this.search = search
      this.page = page
      this.order = {order_asc,order_col}
      this.awaiting_submissions = false
      console.log(this.submissions,this.columns,'??')
    },
  }
}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.display-archive {
  border: 1px solid black;
  button {
    width: 100%;
    text-align: left;
    padding: 0.5rem 1rem;
    cursor: pointer;
    background-color: rgba(0,0,0,0.1);
    &:hover {
      background-color: $text_dark;
      color: white;
    }
  } 
}
.button {
  cursor: pointer;
  height: 42px;
  aspect-ratio: 21/9;
  
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  border: 1px solid $text_dark;
  color: $text_dark;
  &:hover {
    background-color: $text_dark;
    color: $text_light;
  }
}
.archive-dialog {
  border: 1px solid black;
  padding: 32px;
  min-width: 105mm;
  display: flex;
  flex-direction: column;
  gap: 16px;
  visibility: hidden;
  &.open {
    visibility: visible;;
  }
  .buttons {
    display: flex;
    flex-direction: row;
    :last-child {
      margin-left:auto;
    }
  }
}
</style>
